(function () {
  'use strict';

  var backgrounds = [
    ['Bronze Canvas', 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Bronze_Canvas_400x400_f347449d-5c7e-4e4f-b9f4-861b33ece62e.png?v=1784094890'],
    ['Venetian Stucco', 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Venetian_Stucco_400x400_57bc4946-379f-475c-aca7-60cd777cec0d.png?v=1784094890'],
    ['Aged Blue', 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Aged_Blue_400x400_43b78823-d9de-4f57-a355-2dd1ece70317.png?v=1784094891'],
    ['Earth Wash', 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Earth_Wash_400x400_599452be-8a36-48a2-819b-6f7058ba0daa.png?v=1784094892'],
    ['Olive Shadow', 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Olive_Shadow_400x400_8de5f4dd-1b64-48e8-93ca-94be87d212c4.png?v=1784094889'],
    ['Burnished Copper', 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Burnished_Copper_400x400_0689dc70-1bfd-4e55-9813-5b785d8ebee6.png?v=1784094891'],
    ['Olive Patina', 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Olive_Patina_400x400_dde0552f-cdd7-4fb4-b597-a8ac3ef04b31.png?v=1784094889'],
    ['Cathedral Smoke', 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Cathedral_Smoke_400x400_167bcc75-ad00-4031-a55d-e2626c85a52b.png?v=1784094892'],
    ['Storm Blue', 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Storm_Blue_400x400_32c7d373-cbd3-4dd4-87c7-99649bce6a3a.png?v=1784094889'],
    ['Ivory Fresco', 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Ivory_Fresco_400x400_ab4e10f3-5f6a-4afb-a556-a9dd5a96d137.png?v=1784094893'],
    ['Castle Grounds', 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Castle_Grounds_400x400_c5e89c09-e6d4-4d12-a01a-f27b44714431.png?v=1784094892'],
    ['Garden Terrace', 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Garden_Terrace_400x400_76eed2d2-447e-4648-ae60-14c7aac74b6f.png?v=1784094892'],
    ['Old Master Studio', 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Old_Master_Studio_400x400_2d089781-d986-447a-bd64-7ffd6d124543.png?v=1784094889'],
    ["Scholar's Study", 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Scholar_s_Study_400x400_d49c2de7-6d13-4127-823a-dff12d175eb6.png?v=1784094889'],
    ['Candlelit Chamber', 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Candlelit_Chamber_400x400_ed21d523-ae37-4e31-9edc-0c75e647565c.png?v=1784094892'],
    ['Vintage Tapestry', 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Vintage_Tapestry_400x400_0690f0eb-5d02-42cf-8e5e-37ded4cf27e2.png?v=1784094891'],
    ['Royal Palace Hall', 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Royal_Palace_Hall_400x400_e89c2e18-8489-4b6c-826a-fa72c9c44d88.png?v=1784094889'],
    ['Tuscan Balcony', 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Tuscan_Balcony_400x400_62083200-b1cb-4edb-b7f6-e988b0c5b562.png?v=1784094890'],
    ['Countryside Vista', 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Countryside_Vista_400x400_9d47d6e7-cc39-4424-b94a-76fd0094090a.png?v=1784094892'],
    ['Gilded Wall', 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/Gilded_Wall_400x400_135d96f9-3c7e-4dc2-aa45-155108255800.png?v=1784094893']
  ];

  function escapeHtml(value) {
    return value.replace(/[&<>'"]/g, function (char) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char];
    });
  }

  function buildCards() {
    return backgrounds.map(function (item) {
      var name = escapeHtml(item[0]);
      return '<div class="image-slide-box" style="text-align:center">' +
        '<img src="' + item[1] + '" alt="' + name + ' pet portrait background" width="400" height="400" loading="lazy">' +
        '<p class="title-background text-center">' + name + '</p>' +
      '</div>';
    }).join('');
  }

  function findRenaissanceBox() {
    var buttons = document.querySelectorAll('.page_background_accordion_bg');
    for (var i = 0; i < buttons.length; i += 1) {
      if ((buttons[i].textContent || '').trim().toLowerCase() === 'renaissance backgrounds') {
        return buttons[i].closest('.page_background_accordion_box');
      }
    }
    return null;
  }

  function createHero() {
    var hero = document.createElement('section');
    hero.className = 'pg-background-page-hero';
    hero.innerHTML =
      '<div class="pg-background-page-eyebrow">Paw &amp; Glory Background Library</div>' +
      '<h1>Find the perfect setting for <em>their masterpiece</em></h1>' +
      '<p>When your artwork is ready, you can preview your pet against the available backgrounds before approving it. Browse the collections below and keep a note of any favourites.</p>' +
      '<div class="pg-background-page-pills">' +
        '<span class="pg-background-page-pill">Preview before print</span>' +
        '<span class="pg-background-page-pill">Unlimited edits</span>' +
        '<span class="pg-background-page-pill">Chosen during approval</span>' +
      '</div>';
    return hero;
  }

  function createSteps() {
    var steps = document.createElement('div');
    steps.className = 'pg-background-page-intro';
    steps.innerHTML =
      '<div class="pg-background-page-step"><strong>1. Choose your artwork</strong><span>Order your favourite portrait style and upload a clear photo of your pet.</span></div>' +
      '<div class="pg-background-page-step"><strong>2. Preview the options</strong><span>When your proof is ready, view suitable backgrounds behind your finished artwork.</span></div>' +
      '<div class="pg-background-page-step"><strong>3. Approve your favourite</strong><span>Pick the setting you love, request any edits, then approve it for print.</span></div>';
    return steps;
  }

  function initialise() {
    var container = document.querySelector('.page_background-small-container');
    if (!container || document.querySelector('.pg-background-page-shell')) return;

    var center = container.closest('center') || container.parentNode;
    var shell = document.createElement('div');
    shell.className = 'pg-background-page-shell';
    center.parentNode.insertBefore(shell, center);

    var oldHeading = document.querySelector('h2.text-center');
    var oldGifWrap = oldHeading && oldHeading.nextElementSibling;
    var oldCopy = oldGifWrap && oldGifWrap.nextElementSibling;
    if (oldHeading) oldHeading.style.display = 'none';
    if (oldGifWrap && oldGifWrap.querySelector('img')) oldGifWrap.style.display = 'none';
    if (oldCopy && oldCopy.tagName === 'P') oldCopy.style.display = 'none';

    shell.appendChild(createHero());
    shell.appendChild(createSteps());

    var jump = document.createElement('nav');
    jump.className = 'pg-background-page-jump';
    jump.setAttribute('aria-label', 'Jump to background collection');
    jump.innerHTML = '<a href="#renaissance-backgrounds">Renaissance</a><a href="#yellow-art-backgrounds">Yellow Art</a><a href="#watercolour-backgrounds">Watercolour</a><a href="#solid-colours">Solid Colours</a><a href="#patterns">Patterns</a><a href="#pop-art">Pop Art</a>';
    shell.appendChild(jump);

    var heading = document.createElement('div');
    heading.className = 'pg-background-page-heading';
    heading.innerHTML = '<h2>Explore the background collections</h2><p>Tap a collection to browse. The new Renaissance range is marked below.</p>';
    shell.appendChild(heading);

    var library = document.createElement('div');
    library.className = 'pg-background-page-library';
    var boxes = Array.prototype.slice.call(center.querySelectorAll('.page_background_accordion_box'));
    boxes.forEach(function (box) {
      box.removeAttribute('style');
      var button = box.querySelector('.page_background_accordion_bg');
      if (button) {
        var anchor = (button.textContent || '').trim().toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        box.id = anchor;
      }
      library.appendChild(box);
    });
    shell.appendChild(library);

    if (center.parentNode) center.parentNode.removeChild(center);

    var renaissance = findRenaissanceBox();
    if (renaissance) {
      renaissance.classList.add('pg-renaissance-box');
      var slider = renaissance.querySelector('.background_page-slides-item');
      if (slider) slider.innerHTML = buildCards();
    }

    var note = document.createElement('div');
    note.className = 'pg-background-page-note';
    note.textContent = 'Background availability depends on the artwork style you choose. Your proof page will show the options available for your portrait, so there is no need to decide before ordering.';
    shell.appendChild(note);

    window.setTimeout(function () {
      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
        window.jQuery('.background_page-slides-item.slick-initialized').slick('setPosition');
      }
    }, 80);
  }

  initialise();
})();
